import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';
import Card from 'components/Card';
import Steps from 'modules/Security/components/Steps';
import './style.scss';

const Install: FC = () => {
    return (
        <Card form className="fa-install-page">
            <h2>{__('开启两步验证')}</h2>
            <Steps type="mfaEnable" />
            <Outlet />
        </Card>
    );
};

export default Install;
